import React from 'react'; 
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import {Box, IconButton} from "@mui/material";
import {RootState, useAppDispatch, useAppSelector} from "../../../state/state.tsx";
import {closeModal, openModal} from "../../../state/ModalSlice/ModalSlice.ts";
import CloseIcon from "@mui/icons-material/Close";
import {getBankAccountImage} from "../utilityFunctions.ts";
import { selectBankAccounts } from '../../../state/UserStatesV2/userSliceV2.ts';


export default function AllBankAccountsModal() {


    const Dispatch = useAppDispatch();
    // All Bank Accounts
    const AllBankAccounts = useAppSelector(selectBankAccounts);
    // Modal handlers
    const open = useAppSelector((state: RootState) => state.ModalSlice.AllBankAccountsModalOpen)

    function handleClose() {
        Dispatch(closeModal("AllBankAccountsModalOpen"))
    }

    // onClick handlers
    function onClickAddBankAccount(e: any) {
        e.preventDefault()
        Dispatch(openModal("AddBankAccountOpen"))
    }


    return (<React.Fragment>

            <Dialog
                sx={{
                    padding: 0,
                    '& .MuiPaper-root': {
                        borderRadius: '10px',
                    },
                }}
                maxWidth="md"
                open={open}
                PaperProps={{
                    component: 'div',

                }}
            >
                <DialogContent sx={{paddingX: "60px", paddingY: "50px"}} className={"bg-white"}>
                    <div className={"header pb-[20px]"}>
                        <p className={"text-cf_heading font-[600] "}>Bank Accounts</p>
                    </div>
                    <div className={"absolute right-4 top-4"}><IconButton onClick={handleClose}>
                        <CloseIcon/>
                    </IconButton></div>
                    <div className={""}>
                        <div className={""}>
                            <div className={"flex w-full"}>
                                <div className={"w-[550px]"}>
                                    <Box
                                        component={"div"}
                                        // component="form"
                                        sx={{}}
                                    >
                                        <div className={"TextFields flex flex-col gap-4 "}>
                                            {AllBankAccounts.length > 0 ? AllBankAccounts.map((bankAccount, index) => {
                                                return (
                                                    <div key={index}
                                                         className={"flex gap-4 border-[1px] border-gray-300 rounded-lg bg-cc_bg_app p-2 shadow-lg"}>
                                                        <div className={"flex justify-center items-center"}><img
                                                            className={"size-[70px]"}
                                                            src={getBankAccountImage(bankAccount.iFSC.substring(0, 4))}
                                                            alt={"BANK"}/></div>
                                                        <div className={"flex flex-col "}>
                                                            <p><span
                                                                className={"font-semibold"}>Name</span> : {bankAccount.accountName}
                                                            </p>
                                                            <p><span
                                                                className={"font-semibold"}>Acc</span> : {bankAccount.accountNo}
                                                            </p>
                                                            <p><span
                                                                className={"font-semibold"}>IFSC</span> : {bankAccount.iFSC}
                                                            </p>
                                                        </div>

                                                    </div>
                                                )
                                            }) : <div className={"flex  flex-col items-center p-4 justify-center"}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32"
                                                     viewBox="0 0 24 24"
                                                     fill="none" stroke="currentColor" strokeWidth="2"
                                                     strokeLinecap="round"
                                                     strokeLinejoin="round" className="feather feather-info">
                                                    <circle cx="12" cy="12" r="10"></circle>
                                                    <line x1="12" y1="16" x2="12" y2="12"></line>
                                                    <line x1="12" y1="8" x2="12.01" y2="8"></line>
                                                </svg>

                                                No Bank Account Found!
                                            </div>}


                                        </div>
                                        <div className={"flex justify-end mt-4"}>
                                            <button
                                                className={"flex justify-center items-center bg-cc_brand rounded-lg p-1.5 px-4 w-full"}
                                                onClick={onClickAddBankAccount}
                                            >

                                                <svg width="14" height="14" viewBox="0 0 19 18" fill="none"
                                                     xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M9.5 3V15M15.5 9L3.5 9" stroke="#F9FAFB" strokeWidth="2"
                                                          strokeLinecap="round"
                                                          strokeLinejoin="round"/>
                                                </svg>
                                                <span className="text-white ">Add Account</span>

                                            </button>
                                        </div>


                                    </Box>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={"flex gap-2 pt-4 justify-center"}>
                        <button onClick={(e) => {
                            e.preventDefault();
                            handleClose()
                        }}
                                className={"w-[100%] bg-cc_bg-tertiary border border-solid border-gray-500 p-1.5 rounded-lg"}>Close
                        </button>
                    </div>
                </DialogContent>

            </Dialog>

        </React.Fragment>
    );
}